import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const testimonials = [
  {
    quote: "PROVENANCE uncovered critical dependency risks that our internal team had completely missed. The Technology Reality Score gave our IC the confidence to proceed — with a £2.3M price adjustment.",
    attribution: "Managing Director",
    context: "Mid-market PE firm, UK",
    deal: "Series B SaaS acquisition, £45M EV",
  },
  {
    quote: "We used to spend 6 weeks on manual code reviews. PROVENANCE delivered a more comprehensive assessment in 12 days, with quantified remediation costs that fed directly into our model.",
    attribution: "Technology Partner",
    context: "Growth equity fund",
    deal: "Platform consolidation play, £120M combined",
  },
  {
    quote: "The seller had presented their tech as 'cutting-edge'. The Provenance report revealed 40% of their codebase was built on deprecated frameworks with no migration plan. That insight alone saved us from a bad deal.",
    attribution: "Head of Corporate Development",
    context: "Strategic acquirer, fintech",
    deal: "Competitive process, £30M target",
  },
  {
    quote: "As a founder preparing for exit, the pre-sale assessment helped us identify and fix issues before buyers found them. We went into the process with confidence and closed 15% above our initial valuation.",
    attribution: "CEO & Co-founder",
    context: "B2B SaaS company",
    deal: "Pre-sale positioning, successful exit",
  },
];

export function SocialProof() {
  return (
    <section className="py-24 px-4 bg-muted/20">
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-4">
            Trusted by investors and founders
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Anonymised case studies from recent engagements across private equity, 
            growth capital, and strategic M&A.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-card border border-border rounded-2xl p-8 relative"
            >
              <Quote className="absolute top-6 right-6 h-8 w-8 text-primary/15" />
              <p className="text-foreground mb-6 leading-relaxed">
                "{t.quote}"
              </p>
              <div className="border-t border-border pt-4">
                <p className="font-medium text-foreground">{t.attribution}</p>
                <p className="text-sm text-muted-foreground">{t.context}</p>
                <p className="text-xs text-primary/70 mt-1">{t.deal}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
